// @ts-strict-ignore
import React from "react";
import styled from "styled-components";

export interface PictureType {
  className?: string; // allows for styled component passthrough
  src: string;
  webp?: string;
  alt: string;
  imgClassName?: string;
  children?: React.ReactNode;
  height?: number | string;
  width?: number | string;
  style?: React.CSSProperties;
  offset?: number;
}

const getImageType = (src: string) => {
  if (typeof src === "string") {
    if (
      src.match(/\.(gif)$/) != null ||
      src.match(/^data:image\/gif;base64/) != null
    )
      return "image/gif";
    if (
      src.match(/\.(jpeg|jpg)$/) != null ||
      src.match(/^data:image\/jpe?p;base64/) != null
    )
      return "image/jpeg";
    if (
      src.match(/\.(svg)$/) != null ||
      src.match(/^data:image\/svg;base64/) != null
    )
      return "image/svg+xml";
    if (
      src.match(/\.(png)$/) != null ||
      src.match(/^data:image\/png;base64/) != null
    )
      return "image/png";
    return "image/png";
  }
};

const PictureInner = ({
  className,
  src,
  webp,
  alt,
  imgClassName,
  children,
  ...imgProps
}: PictureType) => (
  <picture className={className}>
    {children}
    {webp && <source srcSet={webp} type="image/webp" />}
    <source srcSet={src} type={getImageType(src)} />
    <img className={imgClassName} src={src} alt={alt} {...imgProps} />
  </picture>
);

const Picture = ({ imgClassName, ...rest }: PictureType) => {
  return <PictureInner {...rest} imgClassName={`${imgClassName || ""}`} />;
};

export const FlexPicture = styled(Picture)`
  display: flex;
  justify-content: center;
`;

export default Picture;
